"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMembersProvider = void 0;
const react_1 = __importStar(require("react"));
const AddMembersContext_1 = require("./AddMembersContext");
const AddMembersProvider = ({ children, initialSelectedUsers = [], }) => {
    const [selectedUsers, setSelectedUsers] = (0, react_1.useState)(initialSelectedUsers);
    const resetMembers = () => {
        setSelectedUsers([]);
    };
    const removeUser = (usersList, selectedId) => {
        return usersList.filter(user => user.id !== selectedId);
    };
    const onAdd = (type, selectedId, title) => {
        let clonedSelectedUsers = JSON.parse(JSON.stringify(selectedUsers));
        const foundUser = clonedSelectedUsers.find(user => user.id === selectedId);
        if (foundUser) {
            if (type === foundUser.type) {
                clonedSelectedUsers = removeUser(clonedSelectedUsers, selectedId);
            }
            else {
                clonedSelectedUsers = alterUser(clonedSelectedUsers, selectedId, "type", type);
            }
        }
        else {
            clonedSelectedUsers.push({
                type,
                id: selectedId,
                title,
                refMsg: "",
            });
        }
        setSelectedUsers(clonedSelectedUsers);
    };
    const onAddUser = (selectedId, title) => onAdd(AddMembersContext_1.ADD_USER_TYPE.USER, selectedId, title);
    const onAddGroup = (selectedId, title) => onAdd(AddMembersContext_1.ADD_USER_TYPE.GROUP, selectedId, title);
    const onSendReferral = (selectedId, title) => onAdd(AddMembersContext_1.ADD_USER_TYPE.REFERRAL, selectedId, title);
    const onRemoveUser = (id) => {
        let clonedSelectedUsers = JSON.parse(JSON.stringify(selectedUsers));
        clonedSelectedUsers = removeUser(clonedSelectedUsers, id);
        setSelectedUsers(clonedSelectedUsers);
    };
    const alterUser = (userList, selectedId, key, value) => {
        const foundIndex = userList.findIndex(user => user.id === selectedId);
        userList[foundIndex] = Object.assign(Object.assign({}, userList[foundIndex]), { [key]: value });
        return userList;
    };
    const addReferralMsg = (userInfo, msg) => {
        let clonedSelectedUsers = JSON.parse(JSON.stringify(selectedUsers));
        clonedSelectedUsers = alterUser(clonedSelectedUsers, userInfo.id, "refMsg", msg);
        setSelectedUsers(clonedSelectedUsers);
    };
    const onAddMembers = (callback, minMembers) => __awaiter(void 0, void 0, void 0, function* () {
        if (minMembers && selectedUsers.length < minMembers) {
            throw new Error("minMemberCountError");
        }
        const groupsToAdd = selectedUsers
            .filter(user => user.type === AddMembersContext_1.ADD_USER_TYPE.GROUP)
            .map(user => ({ groupId: user.id }));
        const membersToAdd = selectedUsers
            .filter(user => user.type === AddMembersContext_1.ADD_USER_TYPE.USER)
            .map(user => ({ userId: user.id }));
        const referralsToSend = selectedUsers
            .filter(user => user.type === AddMembersContext_1.ADD_USER_TYPE.REFERRAL)
            .map(user => ({ userId: user.id, referralMessage: user.refMsg }));
        const selectedMembers = {};
        if (groupsToAdd.length > 0)
            selectedMembers["groupsToAdd"] = groupsToAdd;
        if (membersToAdd.length > 0)
            selectedMembers["membersToAdd"] = membersToAdd;
        if (referralsToSend.length > 0)
            selectedMembers["referralsToSend"] = referralsToSend;
        callback && (yield callback(selectedMembers));
    });
    const contextValue = {
        selectedUsers,
        setSelectedUsers,
        onAddUser,
        onSendReferral,
        addReferralMsg,
        onRemoveUser,
        onAddMembers,
        onAddGroup,
        resetMembers,
    };
    return (react_1.default.createElement(AddMembersContext_1.AddMembersContext.Provider, { value: contextValue }, children));
};
exports.AddMembersProvider = AddMembersProvider;
